
import LoadMore from 'vux/src/components/load-more/index.vue'

export default {
components: {
LoadMore,
},
name: 'batch_service',
data() {
return {
buttonTabVal: 0,
start_date: '',
end_date: '',
haveMore: false,
page: 1,
use_table: 0,
min_date: '',
tip: '点击加载更多',
data_list: [],
}
},
methods: {
goBack() {
this.$router.push({
path: './maternal_file',
})
},
onMore() {
this.apiRecordList(true)
},
onchange() {
this.page = 1
console.log('onchange')
this.apiRecordList(false)
},
apiRecordList(more) {
this.$vux.loading.show({
text: '正在加载',
})
if (!more) {
this.data_list = []
}
let that = this
let params = {
token: this.$cookie.get('token'),
page: this.page,
use_table: this.use_table,


}

if (this.start_date != '') {
params.start_date = this.start_date
}
if (this.end_date != '') {
params.end_date = this.end_date
}

console.log('params', params)
Api.memberListApi.batchHeathRecord(params).then((res) => {
console.log(res)
if (res.errcode == 1) {
var dataList = res.data.list
dataList.forEach((item) => {
this.data_list.push(item)
})
if (res.data.page.page_count > this.page) {
this.page++
this.haveMore = true
} else {
this.haveMore = false
}
} else {
this.$vux.toast.show({
type: 'cancel',
text: res.errinfo,
})
}
this.$vux.loading.hide()
})
},
start_date_congirm(value) {
this.formListDetailListPage = 1
this.formListDetailList = []
this.min_date = value
this.start_date = value
this.onchange()
},

end_date_congirm(value) {
this.formListDetailListPage = 1
this.formListDetailList = []
this.end_date = value
this.onchange()
},
},
created() {
this.apiRecordList(false)
},
}



// WEBPACK FOOTER //
// ./src/components/batch_record.vue